import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";

import CssBaseline from "@mui/material/CssBaseline";
import SearchBox from "../../common/components/SearchBox";
import {
  Typography,
  Box,
  Button,
  Menu,
  MenuItem,
  CircularProgress,
  IconButton,
  Badge,
  Divider,
  TextField,
  Tooltip,
} from "@mui/material";
import { connect } from "react-redux";
import { CardContent, Toolbar } from "@mui/material";
import { useHistory } from "react-router-dom";
import {
  getMembershipRequests,
  approveMembershipRequest,
} from "../../../../store/cpd/actions";
import { CSVLink } from "react-csv";
import { useRequiredAuth } from "../../common/guard/requiredAuth";
import ReactPaginate from "react-paginate";
import TrainingProviderAttachmentDialog from "../components/TrainingProviderAttachmentsDialog";
import TrainingProviderProgramsDialog from "../components/TrainingProviderProgramsDialog";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import PreviewTrainingProviderDialog from "../components/PreviewTrainingProviderDialog";

const MembershipRequests = (props) => {
  useEffect(() => {
    document.title = "TMIS | CPD - In Progress trainings";
  }, []);

  const {
    user,
    loading,
    membershipRequests,
    getMembershipRequests,
    approveMembershipRequest,
  } = props;

  const { hasPermissions } = useRequiredAuth();
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecods, setTotalRecods] = useState(0);
  const [loader, setLoader] = useState(false);

  const [itemPerPage, setItemPerPage] = useState(
    window.localStorage.getItem("ITEM_PER_PAGE")
      ? +window.localStorage.getItem("ITEM_PER_PAGE")
      : 10,
  );

  useEffect(() => {
    const _currentPage = 1;
    setCurrentPage(_currentPage);

    const _searchTerm = "";
    setSearchTerm(_searchTerm);

    const query = {
      searchTerm: _searchTerm,
      page: _currentPage,
      size: itemPerPage,
    };

    getMembershipRequests(query, setTotalRecods, setLoader);
  }, [user?.selectedEntity, user?.selectedAcademicYear]);

  const handlePageClick = ({ selected }) => {
    const currentPage = selected + 1;
    setCurrentPage(currentPage);

    const query = {
      searchTerm: searchTerm,
      page: currentPage,
      size: itemPerPage,
    };

    getMembershipRequests(query, setTotalRecods, setLoader);
  };

  const onSearch = (term) => {
    setSearchTerm(term);

    if (term === "") {
      const _currentPage = 1;
      setCurrentPage(_currentPage);

      const _searchTerm = "";
      setSearchTerm(_searchTerm);

      const query = {
        searchTerm: _searchTerm,
        page: _currentPage,
        size: itemPerPage,
      };
      getMembershipRequests(query, setTotalRecods, setLoader);
    }
  };

  return (
    <>
      <div className="px-4 pt-2">
        <div className="border rounded">
          <AppBar position="static" elevation={0} className="app-bar w-100">
            <Toolbar
              style={{
                minHeight: "0px",
                borderBottom: "3px solid #e9ecef",
              }}
              className=" my-0 py-1 bg-light"
            >
              <Typography
                variant="p"
                noWrap
                component="div"
                className="d-flex  align-items-center text-uppercase text-primary font-weight-bold"
              >
                <span className="text-dark">
                  ({membershipRequests.length}) Membership requests
                </span>

                <CSVLink
                  data={membershipRequests}
                  filename={`Membership requests.csv`}
                  className="hidden"
                  id="downloadBTN"
                  target="_blank"
                />
                {hasPermissions([
                  "CPD_TRAINING_PROVIDERS_DOWNLOAD_EXCEL_FILE",
                ]) && (
                  <Tooltip title="Download">
                    <span className="ml-2">
                      <IconButton
                        size="small"
                        disabled={loading || !membershipRequests.length}
                        className=" mr-1"
                        color="primary"
                        onClick={() =>
                          document.getElementById("downloadBTN").click()
                        }
                      >
                        <span className="material-icons">file_download</span>
                      </IconButton>
                    </span>
                  </Tooltip>
                )}
              </Typography>

              <Box sx={{ flexGrow: 1 }} />

              <Box sx={{ display: { xs: "flex", md: "flex" } }}>
                <SearchBox
                  onSearch={onSearch}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      const query = {
                        searchTerm: searchTerm,
                        page: currentPage,
                        size: itemPerPage,
                      };

                      getMembershipRequests(query, setTotalRecods, setLoader);
                    }
                  }}
                  placeholder="Search…"
                />
              </Box>
            </Toolbar>
          </AppBar>
          <div
            style={{
              backgroundColor: "#f3f4f6",
              borderRadius: "0.5rem",
              boxShadow: "0 5px 5px 0 rgb(42 119 144 / 5%)",
              MozBoxShadow: "0 5px 5px 0 rgba(42,119,144,.05)",
              height: "59vh",
              overflowY: "auto",
            }}
            className="px-3"
          >
            {!!membershipRequests?.length && (
              <table className="table table-striped table-hover   fixTableHead">
                <thead>
                  <tr style={{ backgroundColor: "#f0f2f5" }}>
                    <th scope="col">#</th>
                    <th scope="col">RegNo</th>
                    <th scope="col">Organization name</th>
                    <th scope="col">Acronym</th>
                    <th scope="col">Country</th>
                    <th scope="col">Organization Type</th>
                    <th scope="col">email</th>
                    <th scope="col">phone</th>
                    <th scope="col">Address</th>

                    {/* <th scope="col" className="text-center"></th> */}
                    {/* <th scope="col" className="text-center"></th> */}
                    <th scope="col">Status</th>
                    <th scope="col"></th>
                  </tr>
                </thead>

                <tbody>
                  {membershipRequests?.map((item) => (
                    <ItemCard
                      key={item.id}
                      item={item}
                      user={user}
                      loading={loading}
                      approveMembershipRequest={approveMembershipRequest}
                      hasPermissions={hasPermissions}
                    />
                  ))}
                </tbody>
              </table>
            )}

            {!membershipRequests?.length && (
              <div className="jumbotron jumbotron-fluid text-center">
                <div className="container py-5 ">
                  <p className="lead">
                    {loading ? "Fetching data..." : "No record found"}{" "}
                  </p>
                </div>
              </div>
            )}
          </div>
          {!!membershipRequests.length && (
            <div
              className="d-flex justify-content-center  align-items-center"
              style={{ overflow: "hidden" }}
            >
              <>
                <div className="mt-3">
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel={
                      <>
                        <span className="pr-1 d-none d-md-inline">Next</span>
                        <i className="fas fa-angle-double-right"></i>
                      </>
                    }
                    previousLabel={
                      <>
                        <i className="fas fa-angle-double-left"></i>
                        <span className="pl-1  d-none d-md-inline">
                          Previous
                        </span>
                      </>
                    }
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    onPageChange={handlePageClick}
                    pageCount={Math.ceil(totalRecods / itemPerPage)}
                    renderOnZeroPageCount={null}
                    containerClassName="pagination"
                    pageLinkClassName="btn btn-outline-dark btn-sm mr-1 ml-1"
                    previousLinkClassName="btn btn-outline-dark btn-sm mr-1 ml-1"
                    nextLinkClassName="btn btn-outline-dark btn-sm ml-1"
                    activeLinkClassName="active"
                  />
                </div>

                <select
                  className="custom-select custom-select-sm mr-3 ml-2"
                  style={{ width: "100px" }}
                  value={itemPerPage}
                  onChange={(event) => {
                    const itemPerPage = +event.target.value;
                    window.localStorage.setItem("ITEM_PER_PAGE", itemPerPage);
                    setItemPerPage(itemPerPage);
                    const query = {
                      searchTerm: searchTerm,
                      page: currentPage,
                      size: itemPerPage,
                    };
                    getMembershipRequests(query, setTotalRecods, setLoader);
                  }}
                >
                  {[10, 50, 100, 150].map((item, index) => (
                    <option key={index}>{item}</option>
                  ))}
                </select>
              </>
            </div>
          )}
        </div>
      </div>

      {loader && (
        <CircularProgress
          sx={{
            zIndex: (theme) => theme.zIndex.drawer + 1,
            color: "rgb(7, 142, 206)",
            position: "absolute",
            top: "42%",
            left: "50%",
            marginTop: "-12px",
            marginLeft: "-12px",
          }}
          size={40}
          thickness={4}
        />
      )}
    </>
  );
};

const mapStateToProps = ({ user, loading, membershipRequests }) => {
  return { user, loading, membershipRequests };
};
export default connect(mapStateToProps, {
  getMembershipRequests,
  approveMembershipRequest,
})(MembershipRequests);

const ItemCard = (props) => {
  const { loading, user, item, hasPermissions, approveMembershipRequest } =
    props;

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const [showAttachmentsDialog, setShowAttachmentsDialog] = useState(false);
  const [showProviderProgramsDialog, setShowProviderProgramsDialog] =
    useState(false);

  const [statusId, setStatusId] = useState(null);
  const [statusComment, setStatusComment] = useState("");

  const [previewMembershipRequest, setPreviewMembershipRequest] =
    useState(false);

  return (
    <>
      <tr>
        <td className="text-left">{item.no}</td>
        <td className="text-left">
          <strong>{item.id}</strong>
        </td>
        <td className="text-left">{item.name}</td>
        <td className="text-left">{item.acronym || "-"}</td>
        <td className="text-left">{item.countryName}</td>
        <td className="text-left">{item.organizationTypeName}</td>
        <td className="text-left">{item.email}</td>
        <td className="text-left">{item.phone}</td>
        <td className="text-left">{item.district}</td>

        {/* <td className="text-center">
          <button
            onClick={() => setShowProviderProgramsDialog(true)}
            className="btn btn-link btn-sm text-truncate"
          >
            ({item.numOfPrograms}) Programs
          </button>
        </td> */}
        {/* <td className="text-center">
          <button
            onClick={() => setShowAttachmentsDialog(true)}
            className="btn btn-link btn-sm text-truncate"
          >
            ({item.numOfAttachments}) Attachments
          </button>
        </td> */}

        <td className={`text-left`}>
          <span
            className={`badge badge-${
              item.statusId == 2
                ? "success"
                : item.statusId == 3
                  ? "danger"
                  : "secondary"
            }`}
          >
            {item.statusName}
          </span>
        </td>

        <td className="text-right">
          <Button
            variant="outlined"
            onClick={() => setPreviewMembershipRequest(true)}
          >
            View
          </Button>
          {/* {item.statusId === 1 && (
            <div className="d-flex">
              <Button
                className="mr-2"
                variant="contained"
                color="success"
                size="small"
                style={{
                  borderRadius: "8px",
                  height: "30px",
                  alignItems: "center",
                  fontSize: ".6rem",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  textTransform: "initial",
                }}
                onClick={() => {
                  handleCloseMenu();
                  setStatusId(2);
                }}
              >
                Approve
              </Button>

              <Button
                className="mr-2"
                size="small"
                style={{
                  borderRadius: "8px",
                  height: "30px",
                  alignItems: "center",
                  fontSize: ".6rem",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  textTransform: "initial",
                }}
                onClick={() => {
                  handleCloseMenu();
                  setStatusId(3);
                }}
                variant="contained"
                color="error"
              >
                Reject
              </Button>
            </div>
          )} */}
        </td>
      </tr>

      {previewMembershipRequest && (
        <PreviewTrainingProviderDialog
          showDialog={previewMembershipRequest}
          setShowDialog={setPreviewMembershipRequest}
          request={item}
        />
      )}

      {showAttachmentsDialog && (
        <TrainingProviderAttachmentDialog
          showDialog={showAttachmentsDialog}
          setShowDialog={setShowAttachmentsDialog}
          trainingProvider={item}
        />
      )}

      {showProviderProgramsDialog && (
        <TrainingProviderProgramsDialog
          showDialog={showProviderProgramsDialog}
          setShowDialog={setShowProviderProgramsDialog}
          trainingProvider={item}
        />
      )}

      {!!statusId && (
        <ConfirmationDialog
          disabled={statusId === 3 && !statusComment}
          confirmationDialog={!!statusId}
          message={
            <>
              <p className="mt-2">
                Are you sure you want to{" "}
                <strong
                  className={`text-${statusId === 2 ? "success" : "danger"}`}
                >
                  {statusId === 2 ? "approve" : "reject"}
                </strong>{" "}
                this request?
              </p>
              {statusId === 3 && (
                <TextField
                  multiline
                  rows={3}
                  autoFocus
                  fullWidth
                  type="text"
                  size="small"
                  name="reason"
                  label="Reason for rejection"
                  variant="outlined"
                  placeholder="Reason for rejection"
                  value={statusComment}
                  onChange={(e) => {
                    setStatusComment(e.target.value || "");
                  }}
                />
              )}
            </>
          }
          setConfirmationDialog={(e) => setStatusId(null)}
          onYes={() => {
            approveMembershipRequest(
              {
                requestId: item.id,
                statusId,
                statusComment,
              },
              () => setStatusId(null),
            );
          }}
        />
      )}
    </>
  );
};
